import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { trimSlashes } from '../../utilities.js';
import Api from '../../api.js';
import kecko from '../../../../assets/kecko.png';

const CsmSectionLink = (props) => {
  let url = `/sekcia/${props.section._id}`;
  if (props.section.url) {
    url = `/${trimSlashes(props.section.url)}`;
  }
  if (Object.keys(props.params).length > 0) {
    url = `${url}?${Api.objectToParams(props.params)}`;
  }
  if (props.section.redirecturl) {
    return <a href={props.section.redirecturl}>{props.children || props.section.name}</a>;
  } else {
    return (
      <Link to={url} target={props.target}>
        {props.children || props.section.name}
      </Link>
    );
  }
};

export const SectionName = (props) => {
  if (typeof props.children === 'string' && props.children.substr(-2) === 'KE') {
    const height = props.height || 40;
    return [
      props.children.substr(0, props.children.length - 2),
      <img
        src={kecko}
        key='kecko'
        style={{
          height: `${height}px`,
          verticalAlign: 'middle',
          marginLeft: '2px',
          position: 'relative',
          top: `-${height * 0.05}px`,
        }}
        alt=''
      />,
    ];
  }
  return props.children || '';
};

CsmSectionLink.defaultProps = {
  params: {},
};

CsmSectionLink.propTypes = {
  section: PropTypes.object.isRequired,
  children: PropTypes.node,
  target: PropTypes.string,
  params: PropTypes.object, // additional GET parameters
};

export default CsmSectionLink;



// WEBPACK FOOTER //
// ./src/ui/src/component/csmSectionLink/csmSectionLink.js